import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

@Injectable()
export class TitleService {
  private baseTitle: string;

  constructor(private translate: TranslateService, private title: Title) {
    this.baseTitle = 'NKN.Storage';
    // this.baseTitle = this.title.getTitle();
  }

  public resetTitle() {
    this.title.setTitle(this.baseTitle);
  }

  public getTitle(): string {
    return this.title.getTitle();
  }

  public setTitle(titleName: string) {
    this.translate.get(titleName).subscribe((message: string) => {
      this.title.setTitle(`${this.baseTitle} | ${message}`);
    });
  }
}
